export default __webpack_public_path__ + "static/contact-icon-person-8d8a0952ff5218c6623af052fc265c5f.png";